import React, { Component } from 'react';
import styled from 'styled-components';

const AppFooter = styled.div`
    flex: 1;

    position: relative;
    line-height: 1rem;
    max-height: 1.2rem;
    width: 100%;
    border-bottom-right-radius: 9px;
    border-bottom-left-radius: 9px;

    display: flex;
    justify-content: center;
    align-items: center;
    
    font-family: sans-serif;
    font-weight: lighter;
    font-size: 0.675rem;
    text-align: center;
    font-family: 'Montserrat', sans-serif;
    color: #222;

    a {
        font-weight: normal;
        text-decoration: none;
        font-family: 'Montserrat Alternates', sans-serif;
        color: #858C9A

        img {
            display: inline-block;
            vertical-align: text-top;
            
            width: auto;
            height: 0.8rem;
            margin: 0 0.5rem;
            
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
    }
`;

export default class Footer extends Component {

    proceed = ()=> {
        const {  onSwitch, activePage } = this.props;
        onSwitch('privacy' ,{activePage});

    }
    render() {
        const { className, activePage } = this.props;
        return (
            <AppFooter className={className}>
                <a href="https://telbee.io" rel="noopener noreferrer" target="_blank" >
                    <strong>vox</strong> powered by telbee
                </a>
                {( activePage === 'contact'  || activePage === 'send-vox' ) &&
                <>
                <span> &nbsp;-&nbsp;</span>
                <a href="#"  style={{ textDecoration: 'underline #858C9A'}} onClick={()=> this.proceed()} >

                        <span style={{ textDecoration: 'underline #858C9A'}} onClick={()=> this.proceed()} >
 <span>how we use your data</span>
</span>
                </a>
                </>}
            </AppFooter>
        )
    }
}
